import axios from '@/plugins/axios'
import quotes from '@/quotes'

export function getHitokoto() {
	// 本地「一言」句子库，不再请求外部接口
	const quote = quotes[Math.floor(Math.random() * quotes.length)]
	return Promise.resolve(quote)
}

export function getSite() {
	return axios({
		url: 'site',
		method: 'GET'
	})
}